import { render, staticRenderFns } from "./create-categorie.vue?vue&type=template&id=58131a8e&scoped=true"
import script from "./create-categorie.vue?vue&type=script&lang=js"
export * from "./create-categorie.vue?vue&type=script&lang=js"
import style0 from "./create-categorie.vue?vue&type=style&index=0&id=58131a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58131a8e",
  null
  
)

export default component.exports